import { render, staticRenderFns } from "./ProfileStatus.vue?vue&type=template&id=6d9696b8&"
import script from "./ProfileStatus.vue?vue&type=script&lang=js&"
export * from "./ProfileStatus.vue?vue&type=script&lang=js&"
import style0 from "./ProfileStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports